





































import { Component, Vue, Prop } from "vue-property-decorator";
import HorizontalBarChart from "@/components/HorizontalBarChart.vue";
import RealBarChart from "@/components/RealBarChart.vue";
import { CostsService } from "@/services/costs-service";
import { BarChartData } from "@/models/chart-data";
import UserBasic from "@/components/UserBasic.vue";
import { subject as an } from "@casl/ability";

@Component({
  name: "CostsDetails",
  components: {
    UserBasic,
    HorizontalBarChart,
    RealBarChart
  },
})
export default class CostsDetails extends Vue {

  @Prop()
  private isBusy!: boolean;

  @Prop()
  private isError!: boolean;

  totalRows = 1;
  currentPage = 1;
  perPage = 20;
  pageOptions = [10, 20, 50];
  sortBy = "updated_on";
  sortDesc = true;
  sortDirection = "asc";
  filter = null;

  grouped_costs_data: BarChartData = new BarChartData();
  projects_last_year_data: BarChartData = new BarChartData();
  projects_last_month_data: BarChartData = new BarChartData();
  projects_last_week_data: BarChartData = new BarChartData();

  costs_service: CostsService = new CostsService();

  created() {
    this.getChartsData();
  }

  // mounted() {
  // }

  getChartsData() {
    this.isBusy = true;
    this.isError = false;
    this.costs_service
      .getBarChart("grouped_costs")
      .then((response) => {
        this.grouped_costs_data = response;
        this.grouped_costs_data.datasets[0].backgroundColor = "#FF9CB3";
        this.grouped_costs_data.datasets[1].backgroundColor = "#FFE5B1";
        this.grouped_costs_data.datasets[2].backgroundColor = "#7FCEFD";
        this.isBusy = false;
        this.isError = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
        this.isError = true;
      });
    this.costs_service
      .getBarChart("projects_last_year")
      .then((response) => {
        this.projects_last_year_data = response;
        this.projects_last_year_data.datasets[0].backgroundColor = "#FF9CB3";
        this.projects_last_year_data.datasets[0].label = "Last year costs"
        this.isBusy = false;
        this.isError = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
        this.isError = true;
      });
    this.costs_service
      .getBarChart("projects_last_month")
      .then((response) => {
        this.projects_last_month_data = response;
        this.projects_last_month_data.datasets[0].backgroundColor = "#FF9CB3";
        this.projects_last_month_data.datasets[0].label = "Last month costs"
        this.isBusy = false;
        this.isError = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
        this.isError = true;
      });
    this.costs_service
      .getBarChart("projects_last_week")
      .then((response) => {
        this.projects_last_week_data = response;
        this.projects_last_week_data.datasets[0].backgroundColor = "#FF9CB3";
        this.projects_last_week_data.datasets[0].label = "Last week costs"
        this.isBusy = false;
        this.isError = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
        this.isError = true;
      });
  }

}
